import {EventEmitter, Injectable, OnDestroy} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {LocalStorageService} from './localstorage.service';
import {SyncData} from './syncdata.model';
import {DialogComponent} from '../dialog/dialog.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DataModel} from './data.model';
import {PocsagItem} from '../pocsag/pocsag.module';
import {openDB, DBSchema, deleteDB, wrap, unwrap, IDBPDatabase} from 'idb';
import {Fahrzeug} from '../fahrzeuge/fahrzeuge.model';
import {UserSettingItem} from '../user/user.module';
import {MenuComponent} from '../menu/menu.component';
import {StandortData} from '../standort/standort.model';
import {Router} from '@angular/router';

interface MyDB extends DBSchema {
    'fmsstatus': {
        value: {
            id: string;
            issi: string;
            status: string;
            timestamp: string;
            ort: string;
            bezeichnung: string;
            bereich: string;
        };
        key: string;
    };
    'pocsag': {
        value: {
            id: number,
            uid: string,
            zeit: string[];
            bezeichnung: string[];
            farbe: string[];
            nachricht: string;
            icon: string;
        };
        key: string;
    };
    'gps': {
        value: {
            id: number,
            bezeichnung: string;
            funkrufname: string;
            stand: string;
            lat: string;
            lng: string;
        };
        key: string;
    };
}



@Injectable()
export class SyncService implements OnDestroy {
    FahrzeugeDataChanged = new EventEmitter();
    LoadingActive = new EventEmitter<string>();
    private Servicegestartet: any = null;
    private Pocsag_zwischenspeicher:PocsagItem[] = [];
    private APP_VERSION = '4.0.75.7';

    private db: IDBPDatabase<MyDB>;
    public temp_settings:UserSettingItem[] =[];
    private sync_interval = null;

    PocsagData: EventEmitter<any> = new EventEmitter();
    letzter_Datenaustausch:EventEmitter<any> = new EventEmitter();
    neueMenuNumbers:EventEmitter<any> = new EventEmitter();
    neueGPSDaten:EventEmitter<any> = new EventEmitter();


    private InternetVorhanden = true;
    DialogRef: MatDialogRef<DialogComponent>;

    constructor(private http: HttpClient,
                private ls: LocalStorageService,
                private dialog: MatDialog, private router: Router) {
    }


    async open_db() {       // Prüft ob die DB vorhanden ist, legt diese sonst an!
        if (this.db == null) {
            this.db = await openDB<MyDB>('fapp-store', 1, {
                upgrade(db) {
                    db.createObjectStore('fmsstatus');
                    db.createObjectStore('pocsag');
                    db.createObjectStore('gps');
                },
            });
        }
    }


    async sync(art: string) {
        if (art=='initial') console.log ('!!!!!!!!!!! INITIAL !!!!!!!!!');
        await this.open_db();
        this.BereinigenvonaltLasten();

        this.GetDataFromWeb(art);

        if (!this.sync_interval) {
            this.sync_interval = setInterval(() => {
                this.sync('');
            }, 2000);
        }

        // This works
        //await this.db.put('fmsstatus', {id: 1, issi:'1233',state:1,timestamp: 12334, bezeichnung:'jj'}, 1);
        // This fails at compile time, as the 'favourite-number' store expects a number.
        //await this.db.put('favourite-number', 12, 'Jake');
    }


    BereinigenvonaltLasten(){
        localStorage.removeItem('PocsagData');
        localStorage.removeItem('eigenezeit2');
        localStorage.removeItem('Pocsag_letzteAktualisierung');
        localStorage.removeItem('eigenezeit1');
        localStorage.removeItem('settings');
    }



    ngOnDestroy() {
        if (this.sync_interval) {
            clearInterval(this.sync_interval);
            console.log('Sync Intervall gestoppt');
        }
    }



    getAppVersion() {
        return this.APP_VERSION;
    }


    GetDataFromWeb(art:string) {
        let initialaufruf = false;
        let gpsaufruf = false;
        if (!this.sync_interval) {initialaufruf = true;}// Bein INitialaufruf auch Settings und Co!
        else if (art == 'initial')  {initialaufruf = true;} // z.B. beim ParameterWechsel, dass die neuen Daten auch gespeichert werden
        else if (art == 'gps') { gpsaufruf = true;}
        this.LoadingActive.emit('true');
        const params = new HttpParams()
            .set('MachineId', String(localStorage.getItem('MachineId')))
            .set('AuthentificationKey', String(localStorage.getItem('AuthentificationKey')))
            .set('app_version', this.APP_VERSION)
            .set('initial', initialaufruf)
            .set('gpsaufruf', gpsaufruf)
            .set('random', Math.random().toString());

        return this.http.get<DataModel[]>('https://fappback.devhm.de/dataservice.php', {
            params: params
        })
            .subscribe((data: DataModel[]) => {
                this.setAktualisierung();
                if (data.length > 0 ) {
                    console.log(data);
                }
                this.LoadingActive.emit('false');
                for (let i: number = 0; i < data.length; i++) {
                    if (data[i].action == 'pocsag') {
                        console.log("Neue Pocsag Daten!");
                        this.SavePocsagData(data[i].value);
                        if (this.router.url == '/menu') {
                            this.sync('initial');
                        }
                    } else if (data[i].action == 'fmsstatus') {
                        console.log("Neue FMSStatus Daten!");
                        this.SaveFMSStatus(data[i].value);
                        if (this.router.url == '/menu') {
                            this.sync('initial');
                        }
                    } else if (data[i].action == 'GPSFahrzeuge') {
                        console.log("Neue GPSFahrzeug Daten!");
                        this.SaveGPSFahrzeuge(data[i].value);
                    } else if (data[i].action == 'settings') {
                        console.log("Neue SettingsdataDaten!");
                        this.temp_settings = JSON.parse(JSON.stringify(data[i].value));

                        this.temp_settings.forEach((s) => {
                            if (s.id == '152') {this.ls.store('anzeigegroesser',s.value);}
                        });
                    } else if (data[i].action == 'MenuItemsFahrzeug') {
                        this.neueMenuNumbers.emit('FAHRZEUGE@'+data[i].value);
                    }else if (data[i].action == 'MenuItemsPocsag') {
                        this.neueMenuNumbers.emit('POCSAG@'+data[i].value);
                    } else if (data[i].action == 'main settings') {
                        console.log("MAIN-",data[i].value);
                        if (data[i].value == 'unknown') {
                            localStorage.removeItem('MaschineId');
                            localStorage.removeItem('AuthentificationKey');
                            localStorage.removeItem('PocsagData');
                            alert('Gerät ist nicht bekannt!');
                            location.href = '/';
                        }
                        if (data[i].value == 'reload') {
                            location.reload();
                        }

                        if (data[i].value == 'deletedb') {
                            window.indexedDB.deleteDatabase("fapp-store");
                            console.log('deletedb');
                            location.reload();
                        }
                    } else {


                        console.error('unbekannte Data action', data[i].action);
                    }
                }
            });
    }





    getUserSettings () {
        return this.temp_settings;
}



    getData(sub_feld_1: string, sub_value_1: string) {
        if (this.Servicegestartet == null) {
        //    this.realgetData(sub_feld_1, sub_value_1);
            this.Servicegestartet = window.setInterval(() => {
               // this.realgetData('alles', '');
            }, 2000);
        }
    }


    realgetData() {


        //this.LoadingActive.emit('true');
        const params = new HttpParams()
            .set('MachineId', String(localStorage.getItem('MachineId')))
            .set('AuthentificationKey', String(localStorage.getItem('AuthentificationKey')))
            .set('app_version', this.APP_VERSION)
            .set('random', Math.random().toString());

        return this.http.get<DataModel[]>('https://fappback.devhm.de/dataservice.php', {
            params: params,
            //headers: {ignoreLoadingBar: ''}
        })
            .subscribe(
                (data: DataModel[]) => {

                    for (let i: number = 0; i < data.length; i++) {
                        if (data[i].action == 'pocsag') {
                            this.GetPocsagData(data[i].value);
                        } else if (data[i].action == 'main settings') {
                            if (data[i].value == 'unknown') {
                                localStorage.removeItem('MaschineId');
                                localStorage.removeItem('AuthentificationKey');
                                localStorage.removeItem('PocsagData');
                                alert('Gerät ist nicht bekannt!');
                                location.href = '/';
                            }
                            if (data[i].value == 'reload') {
                                location.reload();
                            }
                        } else {
                            console.error('unbekannte Data action', data[i].action);
                        }
                    }


                    /*
                        if (Data.action === 'action') {
                          Data.value = this.vs.decrypt(this.ls.get('User_Key'), Data.value);
                          const values = Data.value.split('#');
                          console.log(values);
                          if (values[0] == 'reload') {location.reload();}
                          if (values[0] == 'message') {
                            this.DialogRef = this.dialog.open(DialogComponent, {
                              data: {titel: 'Nachricht', text: (values[1])}
                            });F
                          }







                          if (values[0] === 'checknumber') {

                            while (this.eingabe == "" || this.eingabe == null) {
                              this.eingabe = prompt('Datenüberprüfung -> Bitte gib Deine Handynummer an');
                            }
                            const params = new HttpParams()
                              .set('key', this.ls.get('User_Key'))
                              .set('name', this.ls.get('User_Name'))
                              .set('handynummer', this.ls.get('handynummer'))
                              .set('checknumber', this.eingabe)
                            this.http.get('https://apps.elw-trave-land.de/services/checknumber.php', {params}).subscribe(res => console.log('res'));
                          }


                          if (values[0] == 'reset') {
                            navigator.serviceWorker.getRegistration('./').then(function (registration) {
                              if (registration) {
                                caches.keys()
                                  .then(function (keyList) {
                                    return Promise.all(keyList.map(function (key) {

                                      console.log("[Service Worker] Removing old cache", key);
                                      return caches.delete(key);

                                    }));
                                  })
                                registration.unregister();
                                location.reload();
                              }
                            });
                          }
                          if (values[0] === 'newkey') {
                            const params = new HttpParams()
                              .set('newkey', values[1])
                              .set('handynummer',  this.ls.get('handynummer'))
                              .set('key', this.ls.get('User_Key'))
                            this.http.get('https://apps.elw-trave-land.de/services/error.php', {params}).subscribe(res => console.log('res'));
                            this.ls.store('User_Key', values[1]);
                            window.location.reload();
                          }
                          this.quittungDataReceived(Data.action);
                        }
                        if (Data.action === 'menuitemnumbers') {
                          const data = JSON.parse(this.vs.decrypt(this.ls.get('User_Key'), Data.value));
                          for (let i=0;i<data.length;i++) {
                            this.menuservice.MenuItemNumberChanged.emit(data[i]);
                          }
                        }


                        if (Data.action === 'Kalender') {
                          //  Data.value = this.vs.decrypt(this.ls.get('User_Key'), Data.value);
                          this.ls.store_KalenderItems(Data.value);
                          this.KalenderDataChanged.emit();
                          this.quittungDataReceived(Data.action);
                        }

                        if (Data.action === 'Personal') {
                          Data.value = this.vs.decrypt(this.ls.get('User_Key'), Data.value);
                          this.ls.store_PersonalItems(Data.value);
                          this.PersonalDataChanged.emit();
                          this.quittungDataReceived(Data.action);
                        }

                        if (Data.action === 'Fahrzeuge') {
                          Data.value = this.vs.decrypt(this.ls.get('User_Key'), Data.value);
                          this.ls.store_FahrzeugeItems(Data.value);
                          this.FahrzeugeDataChanged.emit();
                          this.quittungDataReceived(Data.action);
                        }

                        if (Data.action === 'Einsatzarchiv') {
                          Data.value = this.vs.decrypt(this.ls.get('User_Key'), Data.value);
                          this.ls.store_EinsatzArchiv(Data.value);
                          //this.FahrzeugeDataChanged.emit(); ohne Subscription!!! Tut nicht not!
                          this.quittungDataReceived(Data.action);
                        }
                        this.LoadingActive.emit('false'); */
                }
            );

    }


    getData1(sub_feld_1?, sub_value_1?, sub_feld_2?, sub_value_2?) {

        this.LoadingActive.emit('true');
        const params = new HttpParams()
            .set('key', this.ls.get('User_Key'))
            .set('app_version', this.ls.get('app_version'))
            .set('random', Math.random().toString())
            .set(sub_feld_1, sub_value_1)
            .set(sub_feld_2, sub_value_2);

        return this.http.get('https://apps.elw-trave-land.de/services/sync.php', {
            params: params,
            //headers: {ignoreLoadingBar: ''}
        })

            .subscribe(
                (Data: SyncData) => {
                    //console.log(Data);

                    if (Data.action === 'action') {
                        const values = Data.value.split('#');
                        if (values[0] == 'reload') {
                            location.reload();
                        }
                        if (values[0] == 'message') {
                            this.DialogRef = this.dialog.open(DialogComponent, {
                                data: {titel: 'Nachricht', text: (values[1])}
                            });
                        }





                        if (values[0] == 'reset') {
                            navigator.serviceWorker.getRegistration('./').then(function (registration) {
                                if (registration) {
                                    caches.keys()
                                        .then(function (keyList) {
                                            return Promise.all(keyList.map(function (key) {

                                                console.log('[Service Worker] Removing old cache', key);
                                                return caches.delete(key);

                                            }));
                                        })
                                    registration.unregister();
                                    location.reload();
                                }
                            });
                        }

                        this.quittungDataReceived(Data.action);
                    }


                    if (Data.action === 'Fahrzeuge') {
                        this.ls.store_FahrzeugeItems(Data.value);
                        this.FahrzeugeDataChanged.emit();
                        this.quittungDataReceived(Data.action);
                    }


                    this.LoadingActive.emit('false');
                }
            );

    }


    public savePocsag_zwischenspeicher(data:PocsagItem[]) {
        this.Pocsag_zwischenspeicher= data;
    }

    public getPocsag_zwischenspeicher() {
        return this.Pocsag_zwischenspeicher;
    }

    async SavePocsagData(data: string){
        await this.open_db();
        const neuePocsagData: PocsagItem[] = JSON.parse(JSON.stringify(data));
        console.log('neue Pocsag Daten: ',neuePocsagData.length);
        for (let i=0;i<neuePocsagData.length; i++) {
            await this.db.put('pocsag', {id:parseInt(neuePocsagData[i].id), uid: neuePocsagData[i].uid, zeit: neuePocsagData[i].zeit, farbe:neuePocsagData[i].farbe, nachricht: neuePocsagData[i].nachricht,bezeichnung: neuePocsagData[i].bezeichnung, icon: neuePocsagData[i].icon}, (neuePocsagData[i].id.toString()));
            console.log("Pocsag Data save");
        }
        this.PocsagData.emit();
    }


    async SaveGPSFahrzeuge(data: string){
        await this.open_db().then(()=> this.db.clear('gps'));

        const neueGPSFahrzeugDaten: StandortData[] = JSON.parse(JSON.stringify(data));
        console.log('neue SaveGPSFahrzeuge Daten: ',neueGPSFahrzeugDaten.length);
        for (let i=0;i<neueGPSFahrzeugDaten.length; i++) {
            await this.db.put('gps', {id: neueGPSFahrzeugDaten[i].id, bezeichnung: neueGPSFahrzeugDaten[i].bezeichnung,funkrufname: neueGPSFahrzeugDaten[i].funkrufname, stand:neueGPSFahrzeugDaten[i].stand, lat: neueGPSFahrzeugDaten[i].lat,lng: neueGPSFahrzeugDaten[i].lng}, ''+neueGPSFahrzeugDaten[i].id.toString());
            console.log("GPS Data save");
        }
        this.neueGPSDaten.emit();
    }




    async SaveFMSStatus(data: string){
        await this.open_db();
        const neueFMSStatusData: Fahrzeug[] = JSON.parse(JSON.stringify(data));
        for (let i=0;i<neueFMSStatusData.length; i++) {
            await this.db.put('fmsstatus', {id: neueFMSStatusData[i].id,
                                                            issi: neueFMSStatusData[i].issi,
                                                            status: neueFMSStatusData[i].status,
                                                            timestamp: neueFMSStatusData[i].timestamp,
                                                            bezeichnung: neueFMSStatusData[i].bezeichnung,
                                                            ort:neueFMSStatusData[i].ort, bereich: neueFMSStatusData[i].bereich},(neueFMSStatusData[i].id.toString()));
            console.log("FMS Status save");
        }
        this.FahrzeugeDataChanged.emit();
    }



    setAktualisierung() {
        const now = new Date();
        let time = '';
        if (now.getHours() < 10) {
            time = '0' + now.getHours() + ':';
        } else {
            time = '' + now.getHours() + ':';
        }

        if (now.getMinutes() < 10) {
            time += '0' + now.getMinutes() + ':';
        } else {
            time += '' + now.getMinutes() + ':';
        }

        if (now.getSeconds() < 10) {
            time += '0' + now.getSeconds();
        } else {
            time += '' + now.getSeconds();
        }
       this.letzter_Datenaustausch.emit(time);
    }



    GetPocsagData(data: string) {
        this.SavePocsagData(data);
        const neuePocsagData: PocsagItem[] = JSON.parse(JSON.stringify(data));

        const PocsagDataStringalt: string = String(localStorage.getItem('PocsagData'));
        let PocsagData: PocsagItem[] = [];
        if (PocsagDataStringalt !== 'null') {
            PocsagData = JSON.parse(PocsagDataStringalt);
        } else {
          //  PocsagData.push(new PocsagItem('11111111', ['00:00:00'], ['Start'], ['#ff0000'], 'START', ''));
        }

        for (let i = 0; i < neuePocsagData.length; i++) {
            if (PocsagData[0].nachricht == neuePocsagData[i].nachricht) {
                PocsagData[0].zeit.unshift(neuePocsagData[i].zeit[0]);
                PocsagData[0].bezeichnung.unshift(neuePocsagData[i].bezeichnung[0]);
                PocsagData[0].farbe.unshift(neuePocsagData[i].farbe[0]);
            } else {
                PocsagData.unshift(neuePocsagData[i]);
            }

        }


        const PocsagDataNeuText: string = String(JSON.stringify(PocsagData));

        localStorage.setItem('PocsagData', PocsagDataNeuText);

        let tt: DataModel = new DataModel('action', 'valuePEETTTEREEEE');


        this.PocsagData.emit(tt);
    }


    quittungDataReceived(action: string) {
        const params = new HttpParams()
            .set('key', this.ls.get('User_Key'))
            .set('received', action)
            .set('random', Math.random().toString());

        return this.http.get('https://apps.elw-trave-land.de/services/sync.php', {params})
            .subscribe();
    }

    public setInternet(wert: boolean) {
        this.InternetVorhanden = wert;
    }

    public getInternet() {
        return (this.InternetVorhanden);
    }
}
